import {
  TabSectionType,
  WorkspaceTab,
  WorkspaceTabSection,
} from '@ansys-internal/awf-angular/contributions';
import { Icons } from '@ansys-internal/awc-angular/icons';
import { ConceptSections } from '../../../../../shared/enums';
import { sectionState } from '../../../../../shared/models/section-state';
import { IconType } from '@ansys-internal/awc-angular/icons';
import { AWFRouteItem, AWFSection } from '@ansys-internal/awf-angular/core';

@AWFRouteItem({
  path: ':id',
})
export class RequirementsResultsSelected {}
@AWFRouteItem({
  path: ':compare-result-ids',
})
export class RequirementsComparisonToolIds {}

@AWFRouteItem({
  path: 'comparison_tool',
  children: [RequirementsComparisonToolIds],
})
export class RequirementsComparisonTool {}

@AWFRouteItem({
  path: 'results',
  children: [RequirementsResultsSelected, RequirementsComparisonTool],
})
export class RequirementsResults {}

@AWFSection({
  path: ConceptSections.REQUIREMENT,
  children: [RequirementsResults],
})
export class RequirementsSection implements TabSectionType {
  public type: ConceptSections = ConceptSections.REQUIREMENT;
  public title: string = 'Requirements';
  public icon: IconType = { icon: Icons.PLOTS };
  public disabled: boolean = !sectionState.requirement;

  async getTitle(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<string> {
    return this.title;
  }

  async getIcon(
    tab: WorkspaceTab,
    section: WorkspaceTabSection
  ): Promise<IconType> {
    return this.icon;
  }

  public isDisabled(): Promise<boolean> {
    return new Promise((resolve) => {
      resolve(!sectionState.requirement);
    });
  }

  onChangeRequest(): void {
    this.disabled = !sectionState.requirement;
  }
}
